import { render, staticRenderFns } from "./ReturnConfirmModal.vue?vue&type=template&id=71821ffb"
import script from "./ReturnConfirmModal.vue?vue&type=script&lang=js"
export * from "./ReturnConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports